export const idlFactory = ({ IDL }) => {
  const Result_3 = IDL.Variant({
    'Ok' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Vec(IDL.Text))),
    'Err' : IDL.Text,
  });
  const AwsInstance = IDL.Record({
    'instance_id' : IDL.Text,
    'security_groups' : IDL.Vec(IDL.Text),
    'public_ip' : IDL.Opt(IDL.Text),
    'subnet_id' : IDL.Text,
    'tags' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    'platform' : IDL.Opt(IDL.Text),
    'state' : IDL.Text,
    'private_ip' : IDL.Opt(IDL.Text),
    'instance_type' : IDL.Text,
    'launch_time' : IDL.Text,
    'vpc_id' : IDL.Text,
    'availability_zone' : IDL.Text,
  });
  const DiscoveryResult = IDL.Record({
    'region' : IDL.Text,
    'discovery_time' : IDL.Nat64,
    'running_count' : IDL.Nat32,
    'stopped_count' : IDL.Nat32,
    'discovered_instances' : IDL.Vec(AwsInstance),
    'total_count' : IDL.Nat32,
  });
  const Result_1 = IDL.Variant({ 'Ok' : DiscoveryResult, 'Err' : IDL.Text });
  const ServiceMapping = IDL.Record({
    'protocol' : IDL.Text,
    'service_name' : IDL.Text,
    'instance_id' : IDL.Text,
    'port' : IDL.Opt(IDL.Nat16),
    'health_endpoint' : IDL.Opt(IDL.Text),
    'dependencies' : IDL.Vec(IDL.Text),
  });
  const Result_2 = IDL.Variant({
    'Ok' : IDL.Vec(ServiceMapping),
    'Err' : IDL.Text,
  });
  return IDL.Service({
    'analyze_service_dependencies' : IDL.Func(
        [IDL.Text],
        [Result_3],
        ['query'],
      ),
    'discover_ec2_instances' : IDL.Func([IDL.Text], [Result_1], ['query']),
    'discover_services_on_instance' : IDL.Func(
        [IDL.Text],
        [Result_2],
        ['query'],
      ),
    'get_service_topology' : IDL.Func(
        [],
        [IDL.Vec(IDL.Tuple(IDL.Text, IDL.Vec(IDL.Text)))],
        ['query'],
      ),
    'get_unboundata_service_map' : IDL.Func(
        [],
        [IDL.Vec(IDL.Tuple(IDL.Text, IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text))))],
        ['query'],
      ),
  });
};
export const init = ({ IDL }) => { return []; };
